module.exports = __webpack_public_path__ + "static/media/book-search-engine.7f2f9789.jpg";